import { MAX_UTIL_URL } from '../config';

/**
 * Application route constants
 * Centralized location for all route paths
 */
export const ROUTES = {
  HOME: '/',
  MEME: '/meme',
  CREATE_COIN: '/create-coin',
  VAULTS: '/vaults',
  MAX_UTILITIES: MAX_UTIL_URL,
  PROFILE: '/profile/:address',
  UPCOMING: '/upcoming/:address',
  TRADING: '/trading/:address',
  TRADING_MEME: '/trading-meme/:address',
  TRADING_DEFAI: '/trading-defai/:address',
};

/**
 * Helper function to generate route paths with parameters
 * @param route Base route with parameter placeholders
 * @param params Object containing parameter values
 * @returns Formatted route with parameters replaced
 */
export const generatePath = (route: string, params: Record<string, string>) => {
  let path = route;
  Object.entries(params).forEach(([key, value]) => {
    path = path.replace(`:${key}`, value);
  });
  return path;
};
